var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import './MenubarRight.css';
import { MenubarUseronline_ } from './UserOnline/MenubarUseronline_';
import { MenubarIconInfo_ } from './Info/MenubarIconInfo_';
import { MenubarIconEdit } from './Edit/MenubarIconEdit';
import { MenubarIconPremium } from './Premium/MenubarIconPremium';
import { MenubarIconReportError } from './ReportError/MenubarIconReportError';
import { AvailableTooltip } from '../../../components/other/AvailableTooltip';
import { MenubarIconMore_ } from './More/MenubarIconMore_';
import { MenubarIconSettings_ } from './Settings/MenubarIconSettings_';
import { MenubarIconStatistic_ } from "./Statistic/MenubarIconStatistic_";
let MenubarRight_ = class MenubarRight_ extends React.PureComponent {
    render() {
        const { app } = this.props;
        if (!app.appBoot.isContentRendered)
            return null;
        return (React.createElement("div", { style: { justifyContent: 'flex-end', display: 'flex' } },
            app.appMode.isInPreviewMode && (React.createElement(AvailableTooltip, { title: "Anwort zur\u00FCcksetzen" },
                React.createElement("div", { className: "MenubarRightIconButton", style: { cursor: 'pointer' }, onClick: !!app.question && app.question.questionEdit.resetAnswer },
                    React.createElement("i", { className: "far fa-sparkles" })))),
            app.appMode.isInPreviewMode && (React.createElement(AvailableTooltip, { title: "Vorschaumodus verlassen" },
                React.createElement("div", { className: "MenubarRightIconButton", style: { backgroundColor: '#080808', cursor: 'pointer' }, onClick: app.solidEdit.editMode.quitPreviewMode },
                    React.createElement("i", { className: "fas fa-eye" })))),
            React.createElement(MenubarIconStatistic_, { app: app }),
            React.createElement(MenubarIconPremium, { app: app }),
            React.createElement(MenubarIconSettings_, { app: app }),
            React.createElement(MenubarIconReportError, { app: app }),
            React.createElement(MenubarIconEdit, { app: app }),
            React.createElement(MenubarIconMore_, { app: app }),
            React.createElement(MenubarIconInfo_, { app: app }),
            React.createElement(MenubarUseronline_, { app: app })));
    }
};
MenubarRight_ = __decorate([
    observer
], MenubarRight_);
export { MenubarRight_ };
